import { IColuna } from 'app/types/IColuna'
import React from 'react'

export type TdProps = {
    nomeColuna: string
    colunas?:IColuna[]
} & React.PropsWithChildren<any>

export const Td = (props: TdProps) => {
    return <>
        {props.colunas.find(c => c.Nome)?.Selecionada == true && <td 
            className={props.className}
            style={props.style}>
            {props.children}
        </td>}
    </>
}